import { useEffect } from 'react';
import { createPortal } from 'react-dom';
import { Pressable, StyleSheet, Text, View } from 'react-native';
import { useAnalytics } from 'services/analytics/useAnalytics';
import { calcSizeForTv } from 'utils/index';
import { Platform } from 'utils/platform';

import HexagonalExclamation from 'components/Icons/HexagonalExclamation';
import { WebDiv } from 'components/WebDiv';

type TvExitConfirmationProps = {
  onClose: () => void;
};

export const TvExitConfirmation: React.FC<TvExitConfirmationProps> = ({ onClose }) => {
  const analytics = useAnalytics();

  const handleExit = () => {
    analytics.triggerTvExitConfirmationExitActionEvent();

    if (window.tizen !== undefined) {
      try {
        // @ts-ignore
        tizen?.application?.getCurrentApplication()?.exit();
      } catch (error) {
        console.error(error);
        window.close();
      }
    } else {
      window.close();
    }
  };

  const handleCancel = () => {
    onClose();
    analytics.triggerTvExitConfirmationCancelActionEvent();
  };

  useEffect(() => {
    analytics.triggerTvExitConfirmationViewEvent();
  }, []);

  if (!Platform.isWebTV) return null;

  return createPortal(
    <WebDiv className="exit-modal__container navigation-container navigation-priority">
      <View style={styles.content}>
        <HexagonalExclamation
          width={calcSizeForTv(72).toString()}
          height={calcSizeForTv(72).toString()}
        />
        <Text style={styles.title}>Não vai, não!</Text>
        <Text style={styles.description}>Quer mesmo fechar o aplicativo?</Text>
        <View style={styles.buttons}>
          <Pressable
            onPress={handleCancel}
            role="button"
            style={[styles.button, { marginRight: calcSizeForTv(21) }]}>
            <Text style={styles.buttonText}>Voltar pro app</Text>
          </Pressable>
          <Pressable onPress={handleExit} role="button" style={styles.button}>
            <Text style={styles.buttonText}>Sair do Bandplay</Text>
          </Pressable>
        </View>
      </View>
    </WebDiv>,
    document.getElementById('root')!
  ) as React.ReactPortal;
};

const styles = StyleSheet.create({
  content: {
    flexDirection: 'column',
    alignItems: 'center',
  },
  title: {
    fontFamily: 'Inter_900Black, system-ui, sans-serif',
    fontSize: calcSizeForTv(48),
    fontWeight: '900',
    color: '#ffffff',
    margin: 0,
    marginTop: calcSizeForTv(24),
    marginBottom: calcSizeForTv(32),
  },
  description: {
    fontFamily: 'Inter_700Bold, system-ui, sans-serif',
    fontSize: calcSizeForTv(32),
    fontWeight: '600',
    color: '#ffffff',
    margin: 0,
    marginBottom: calcSizeForTv(64),
  },
  buttons: {
    flexDirection: 'row',
    height: calcSizeForTv(64),
  },
  button: {
    backgroundColor: 'none',
    padding: 0,
    margin: 0,
    width: calcSizeForTv(390),
    borderWidth: 3,
    borderColor: '#2240ff',
    borderRadius: 32,
    alignItems: 'center',
    justifyContent: 'center',
  },
  buttonText: {
    fontFamily: 'Inter_700Bold, system-ui, sans-serif',
    fontSize: calcSizeForTv(24),
    fontWeight: '600',
    color: '#ffffff',
  },
});
